import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old entity-type creation links redirect to Memory's creation state. */
export const Route = createFileRoute("/$owner/entity-types/new")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/$owner/data",
			params: { owner: params.owner },
			search: { create_type: "true" },
			replace: true,
		});
	},
});
